import * as React from "react";
import { getResponsiveStyles } from "../../lib/embed";
import { ILog } from "@ihr-radioedit/inferno-core";
import { RESPONSIVE_EMBED_MIN_WIDTH } from "../index";
import { SanitizedEmbed } from "./SanitizedEmbed.component";
import type { EmbedLegacyProps } from "@ihr-radioedit/inferno-core";

const log = ILog.logger("GenericResponsive.component");

interface GenericResponsiveLegacyProps extends EmbedLegacyProps {
  ratio?: "16by9" | "4by3";
}

export const GenericResponsiveLegacy = (props: GenericResponsiveLegacyProps) => {
  const { width = 0, height = 0 } = props.attributes || {};
  log.debug("ratio = ", props.ratio);
  const itemClass = [];
  let styles: React.CSSProperties = {};
  if (width >= RESPONSIVE_EMBED_MIN_WIDTH) {
    styles = getResponsiveStyles("" + width, "" + height);
    itemClass.push("embed-responsive", `embed-responsive-${props.ratio}`);
  } else {
    itemClass.push("embed-static");
    styles.width = width || "auto";
    styles.height = height || "auto";
  }
  return <SanitizedEmbed html={props.html} classList={itemClass} styles={styles} />;
};

(GenericResponsiveLegacy as any).defaultProps = {
  ratio: "16x9",
};

export default GenericResponsiveLegacy;
